/**
 * Origem Flow: estado de colapso das seções da sidebar (estilo "Espaços" do
 * ClickUp), persistido no localStorage como um objeto {chave: true}.
 */
const STORAGE_KEY = 'origemFlowSidebarCollapsed'

export function readCollapsedSections() {
  try {
    const value = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}')
    return value && typeof value === 'object' ? value : {}
  } catch (error) {
    return {}
  }
}

export function writeCollapsedSections(sections) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(sections))
  } catch (error) {
    // Sem localStorage o colapso só não persiste entre sessões.
  }
}
